import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import "../../../assets/styles/local/ServerTimeOutPage.css";
import logo from "../../../assets/icons/Group 1.svg";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { API_URL } from "../../../redux/constants/type";

const ServerTimeOutPage = () => {
  const location = useLocation();
  const [serverStatus, setServerStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [server, setServer] = useState({
    instanceId: "",
    redirectUrl: "",
    companyId: "",
  });

  useEffect(() => {
    if (location.state?.data) {
      const { instanceId, redirectUrl, companyId } = location.state?.data;
      if (instanceId) {
        setServer({ instanceId, redirectUrl, companyId });
      } else {
        window.location.href = "/server-login";
      }
    } else {
      window.location.href = "/server-login";
    }
  }, [location]);

  useEffect(() => {
    if (server.instanceId) {
      fetchServerStatus();
    }
  }, [server]);

  const fetchServerStatus = () => {
    setLoading(true);
    axios
      .post(`${API_URL}/api/EC2/status?instanceId=${server.instanceId}`)
      .then((res) => {
        setLoading(false);
        const serverResponse = res.data?.value || "";
        setServerStatus(serverResponse);
      });
  };

  const startServer = () => {
    setLoading(true);
    axios
      .post(
        `${API_URL}/api/EC2/start-instance?instanceId=${server.instanceId}&companyId=${server.companyId}`
      )
      .then((res) => {
        setTimeout(() => {
          // setLoading(false);
          window.location.href = server.redirectUrl;
        }, 25000);
      });
  };

  const stopServer = () => {
    setLoading(true);
    axios
      .post(
        `${API_URL}/api/EC2/stop-instance?instanceId=${server.instanceId}&companyId=${server.companyId}`
      )
      .then((res) => {
        setTimeout(() => {
          // setLoading(false);
          window.location.href = "/server-login";
        }, 15000);
      });
  };

  const redirectToWebsite = () => {
    window.location.href = server.redirectUrl;
  };

  const handleClick = () => {
    if (serverStatus == "stopped") {
      startServer();
    } else if (serverStatus == "running") {
      // stopServer();
      redirectToWebsite();
    } else {
      fetchServerStatus();
    }
  };

  const actionButtonName = useMemo(() => {
    if (serverStatus) {
      if (serverStatus == "stopped") {
        return "Start";
      } else if (serverStatus == "running") {
        return "Go";
      } else {
        return `${serverStatus.charAt(0).toUpperCase()}${serverStatus.substring(
          1
        )}...`;
      }
    }
    return "Loading...";
  }, [serverStatus]);

  return (
    <div className="policy_main d-flex align-items-center justify-content-center">
      <div className="d-flex align-items-center justify-content-center w-50">
        <img className="logo" src={logo}></img>
      </div>
      <div className="d-flex flex-column w-50 text-white">
        <div className="font_dim w-75 pe-4">
          <p className="heading_text">
            Hi there! <br /> Welcome to the Playground.
          </p>
          <p>
            Please note, this is not your Live environment, for day to day use.{" "}
          </p>
          <p>
            {" "}
            This environment is used by our Spire Tech Team to unleash the
            latest updates and changes. Safe for testing and reviewing and
            awaiting your go-ahead.{" "}
          </p>
          <p className="fw-bold">
            The Playground is also perfect for training purposes. Play around as
            much as you like, and you can not go wrong here.
          </p>
          <p>
            To save lots of CO2 this environment isn’t live yet, however it is
            accessible 24/7. Click ‘Start’ to access the Playground. It will be
            up in less than 1 minute, and gives you access for 1 hour - every
            time you click ‘Start’.
          </p>
          <p className="fw-bold"> Let’s play!</p>
        </div>
        <div className="mt-5">
          <button
            className="start_btn"
            disabled={loading}
            onClick={handleClick}>
            {loading ? <CircularProgress size={25} /> : actionButtonName}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServerTimeOutPage;
